// extracted by mini-css-extract-plugin
export default {"container":"TransactionSummary_container__08WpR","section":"TransactionSummary_section__qBDqo"};